import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAuthModal } from '../../contexts/AuthModalContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const { isAuthModalOpen, openAuthModal } = useAuthModal();
    const navigate = useNavigate();

    useEffect(() => {
        // Se não estiver carregando e não houver usuário, abra o modal.
        if (!loading && !user) {
            openAuthModal();
        }
    }, [loading, user, openAuthModal]);

    useEffect(() => {
        // Se o modal for fechado e o usuário ainda não estiver logado,
        // navegue de volta para a página anterior.
        if (!loading && !user && !isAuthModalOpen) {
            // Usar um pequeno atraso pode evitar problemas de renderização concorrente
            setTimeout(() => navigate(-1), 0);
        }
    }, [loading, user, isAuthModalOpen, navigate]);

    // Enquanto carrega, não renderize nada para evitar piscar de conteúdo.
    if (loading) {
        return null;
    }

    // Se houver um usuário, renderize o conteúdo protegido.
    // Caso contrário, retorna null, pois a lógica de redirecionamento/modal está sendo tratada.
    return user ? children : null;
};

export default ProtectedRoute;